import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Injects the Google Search Console verification <meta> tag site-wide.
 * Reads from site_settings.google_site_verification — admin can paste & save
 * whenever they get the value from Search Console, no redeploy needed.
 * GA4 / Meta Pixel / Google Ads tracking is handled separately by TrackingPixels.jsx.
 */
const SiteScripts = () => {
  const [verification, setVerification] = useState('');

  useEffect(() => {
    let mounted = true;
    axios.get(`${BACKEND_URL}/api/cms/settings`)
      .then(res => {
        if (mounted && res.data?.google_site_verification) {
          setVerification(res.data.google_site_verification.trim());
        }
      })
      .catch(() => { /* silent — tracking is optional */ });
    return () => { mounted = false; };
  }, []);

  if (!verification) return null;

  return (
    <Helmet>
      <meta name="google-site-verification" content={verification} />
    </Helmet>
  );
};

export default SiteScripts;
